import React from 'react';
import { Box, Typography, CircularProgress, Alert } from '@mui/material';
import { apiService } from '../services/api';

interface SecureImageProps {
  s3Key?: string;
  s3Url?: string;
  alt: string;
  maxHeight?: number | string;
  maxWidth?: number | string;
  onClick?: () => void;
  showError?: boolean;
  showLoading?: boolean;
  originalName?: string;
}

const SecureImage: React.FC<SecureImageProps> = ({
  s3Key,
  s3Url,
  alt,
  maxHeight = '300px',
  maxWidth = '100%',
  onClick,
  showError = true,
  showLoading = true,
  originalName,
}) => {
  // Usa l'endpoint proxy se abbiamo s3Key, altrimenti fallback all'URL diretto
  const imageUrl = s3Key ? apiService.getImageUrl(s3Key) : s3Url;

  if (!imageUrl) {
    return (
      <Box 
        display="flex" 
        alignItems="center" 
        justifyContent="center"
        minHeight="200px"
        sx={{ border: '1px dashed', borderColor: 'divider', borderRadius: 1 }}
      >
        <Typography variant="body2" color="text.secondary">
          Immagine non disponibile
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      {originalName && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          {originalName}
        </Typography>
      )}
      <Box
        component="img"
        src={imageUrl}
        alt={alt}
        sx={{
          maxWidth,
          maxHeight,
          objectFit: 'contain',
          borderRadius: 1,
          border: '1px solid',
          borderColor: 'divider',
          cursor: onClick ? 'pointer' : 'default',
          '&:hover': onClick ? {
            opacity: 0.8,
          } : {},
        }}
        onClick={onClick}
      />
      <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
        {onClick ? 'Clicca per aprire in una nuova finestra' : 'Immagine protetta'}
      </Typography>
    </Box>
  );
};

export default SecureImage;
